import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { fileNameByHeaders } from "@utils/index";
import { inject, injectable } from "inversify";
import { IQueryTitlesDTO } from "../dtos/IQueryTitlesDTO";
import { IDownloadTitlesService } from "../models/IDownloadTitlesService";

@injectable()
export class DownloadTitlesService implements IDownloadTitlesService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  public async execute(
    data: IQueryTitlesDTO
  ): Promise<[string, string | null]> {
    const { data: titleFile, headers } = await this.httpInstance.getWithHeaders<
      BinaryType
    >("/reports/financialDocs", {
      params: {
        ...data,
        action: "BP",
      },
      responseType: "arraybuffer",
    });

    let url = window.URL.createObjectURL(
      new Blob([titleFile], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
    );

    return [url, fileNameByHeaders(headers)];
  }
}
